import styles from "./verifyOtp.module.scss";
import { BounceLoader } from "react-spinners";
import OtpInput from "react-otp-input";
import { useState } from "react";
import TimerButton from "../timer-button/TimerButton";

export interface VerifyOtpProps {
	email?: string;
	otpLength?: number;
	handleVerifyButton: (otp: string) => void;
	handleResendOtp: () => void;
	actionLaoding: boolean;
	onCloseDialog: () => void;
}

const VerifyOtp: React.FC<VerifyOtpProps> = ({ email, actionLaoding, handleVerifyButton, handleResendOtp, otpLength = 6, onCloseDialog }) => {
	const [otp, setOtp] = useState("");
	return (
		<div className={styles.container}>
			<div className={styles.header}>
				OTP
				<div className={`link`}>Need Help?</div>
				<svg className={styles.closeButton} width="20" height="20" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={onCloseDialog}>
					<path d="M15.75 15.75L9 9M9 9L2.25 2.25M9 9L15.75 2.25M9 9L2.25 15.75" stroke="black" strokeWidth="2" stroke-linecap="round" stroke-linejoin="round"/>
				</svg>
			</div>
			<div className={styles.contentContainer}>
				{email && <div className={styles.inputLabel}>Enter the code we've sent by mail to {email}</div>}
				<OtpInput value={otp} onChange={setOtp} numInputs={otpLength} containerStyle={styles.otpContainer} renderInput={props => <input {...props} />} />
				<button className={`standardButton ${styles.verifyButton}`} onClick={() => handleVerifyButton(otp)}>
					{actionLaoding ? <BounceLoader color="#DE841B" size={25} /> : "Verify"}
				</button>
				<p><b>Important: </b>If you do not receive the email in your inbox, please check your spam or junk folder as it may have been filtered by your email provider.</p>
				<div className={styles.resendContainer}>
					Didn't receive the code? <TimerButton timerLength={180} onClick={handleResendOtp} />
				</div>
			</div>
		</div>
	);
};
export default VerifyOtp;
